/**
 * body要素にpageNamesに含まれるクラスがついているか判定
 * @param {string[]|string} pageNames
 * @returns {boolean}
 */
export function isPage(...pageNames) {
  return pageNames.some((pageName) => document.body.classList.contains(pageName));
}

/**
 * ハンバーガーメニュー
 * @param {string} hamburgerId - The ID of the hamburger menu element
 * @param {string} navId - The ID of the navigation element
 * @param {string} activeClass - The class to toggle for active state
 */
export class HamburgerMenu {
  constructor(hamburgerId, navId, activeClass) {
    this.hamburger = document.getElementById(hamburgerId);
    this.hamburgerNav = document.getElementById(navId);
    this.activeClass = activeClass;

    // Bind the toggleNav method to the class instance
    this.toggleNav = this.toggleNav.bind(this);
    this.checkWindowSize = this.checkWindowSize.bind(this);

    // Initial check and attach event listeners if needed
    this.checkWindowSize();

    // Attach resize event listener to handle window resizing
    window.addEventListener('resize', this.checkWindowSize);
  }

  checkWindowSize() {
    const isMobile = window.innerWidth <= 768;

    if (isMobile && !this.hamburger._isListening) {
      this.hamburger.addEventListener('click', this.toggleNav);
      this.hamburgerNav.addEventListener('click', this.toggleNav);
      this.hamburger._isListening = true;
    } else if (!isMobile && this.hamburger._isListening) {
      this.hamburger.removeEventListener('click', this.toggleNav);
      this.hamburgerNav.removeEventListener('click', this.toggleNav);
      this.hamburger._isListening = false;
    }
  }

  toggleNav() {
    this.hamburger.classList.toggle(this.activeClass);
    this.hamburgerNav.classList.toggle(this.activeClass);
    document.body.classList.toggle('nav_active');
  }
}


/**
 * ローディング
 * @param {string} ID - remove contents ID
 * @param {number} time - reading time
 */
export function webStorage (removeID,time = 500) {
  setTimeout(() => {
    document.body.classList.remove('is-nowloading');
  }, time);
  
  if (! sessionStorage.getItem('access')) {
    sessionStorage.setItem('access', 'true');
    document.body.classList.add('is-firstloading');
  }else {
    const loading = removeID ? document.getElementById(removeID) : false;
    if( loading ){
      loading.remove();
    }
  }
}


/**
 * ページ遷移
 * @param {number} time - reading time
 * @param {string} className - reading time
 */
export function pageTransition (time = 500,className) {
  const selector = className ? className : 'a:not([href*="#"]):not([target]):not([href*="tel:"]):not(.boxer):not([data-gallery="wp-images"])';
  const linkEls = [
    ...document.querySelectorAll(selector),
  ];
  if( linkEls ) {
    const currentHostName = window.location.hostname;
    linkEls.forEach((linkEl) => {
      linkEl.addEventListener("click", (e) => {
        if ((e.ctrlKey && !e.metaKey) || (!e.ctrlKey && e.metaKey)) return;
        e.preventDefault();
        e.stopPropagation();
        let url      = linkEl.getAttribute("href");
        let data_url = linkEl.getAttribute("data-href");
        if ( ( url !== "" && url.indexOf(currentHostName) ) || ( data_url !== "" && data_url.indexOf(currentHostName) ) ) {
          document.body.classList.add('is-nowloading');
          setTimeout(() => {
            window.location = url;
          }, time);
        }
      }, false);
    });
  }
}

/**
 * span分割
 * @param {string} selector - CSS selector for the elements to wrap
 */
export function wrapWordsInSpan(selector) {
  const elements = document.querySelectorAll(selector);
  if (elements) {
    elements.forEach(element => {
      const lines = element.innerText.split('\n');
      const hasMultipleLines = lines.length > 1;

      const wrappedLines = lines.map(line => {
        const characters = line.split('');
        const wrappedCharacters = characters.map(char => {
          if (char === ' ') {
            return `<span class="char-space">${char}</span>`;
          } else {
            return `<span>${char}</span>`;
          }
        }).join('');

        return hasMultipleLines ? `<span class="char-line">${wrappedCharacters}</span>` : wrappedCharacters;
      }).join(hasMultipleLines ? '' : '');

      element.innerHTML = wrappedLines;
    });
  }
}

/**
 * スクロールヒント
 * @param {string} selector - CSS selector for the elements to wrap
 */
export function scrollHint (selector) {
  const scrollContainers = document.querySelectorAll(selector);

  scrollContainers.forEach((scrollable) => {
      scrollable.addEventListener('scroll', () => {
          const horizontalScroll = scrollable.scrollLeft;
          const verticalScroll = scrollable.scrollTop;

          if (horizontalScroll > 0) {
            scrollable.classList.add('scroll-horizontal');
          } else {
            scrollable.classList.remove('scroll-horizontal');
          }

          if (verticalScroll > 0) {
            scrollable.classList.add('scroll-vertical');
          } else {
            scrollable.classList.remove('scroll-vertical');
          }
      });
  });
}